import {Button} from '@/components/ui/button/Button'
import {Modal} from '@/components/ui/modal/Modal'
import {Trans, useTranslation} from 'react-i18next'
import {StyledButtonWrapper, StyledEmail, StyledDescription} from './style'
import {envVars} from '@/envVars'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

type ContactUsModalProps = {
    onClose: () => void
}

export const ContactUsModal: React.FC<ContactUsModalProps> = ({onClose}) => {
    const {t} = useTranslation()
    const contactUsEmail = envVars.VITE_ARYA_CONTACT_EMAIL
    const contactUsUrl = envVars.VITE_ARYA_CONTACT_URL

    return (
        <Modal onClose={onClose} title={t('commons:contact_us')} titleAlignment="start" width="fit-content">
            <Flexbox gap={4} align="center">
                {contactUsEmail && (
                    <>
                        <StyledDescription>
                            <Trans
                                i18nKey="contact_us_modal:description"
                                components={{
                                    span: (
                                        <StyledEmail onClick={() => window.open(`mailto:${contactUsEmail}`, '_blank')}>
                                            {contactUsEmail}
                                        </StyledEmail>
                                    )
                                }}
                                values={{EMAIL: contactUsEmail}}
                            />
                        </StyledDescription>
                    </>
                )}
            </Flexbox>

            <StyledButtonWrapper>
                <Button onClick={() => window.open(contactUsUrl, '_blank', 'noopener,noreferrer')}>
                    {t('commons:contact_us')}
                </Button>
            </StyledButtonWrapper>
        </Modal>
    )
}

ContactUsModal.displayName = 'ContactUsModal'
